module.exports = __webpack_public_path__ + "img/atencion-salud.093d65c3.png";